"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.match");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _broker = require("@/api/broker");
var _vuex = require("vuex");
var _default = exports.default = {
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      systemType: false,
      brokerIncomeInfo: {
        begin_date: '',
        end_date: '',
        total: 0,
        brokerName: '',
        brokerId: '',
        authCode: '',
        areaCode: '',
        countryCode: '',
        guildCount: 0,
        allAmount: 0,
        agentAmount: 0,
        guildWageAmount: 0,
        bdWageAmount: 0,
        salariedNum: 0,
        totalAnchors: 0,
        activeAnchors: 0
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roles'])), {}, {
    isBdRole: function isBdRole() {
      return this.roles.includes('bd');
    }
  }),
  mounted: function mounted() {
    this.systemType = this._isMobile();
  },
  created: function created() {
    this.getBrokerIncomeInfo();
  },
  methods: {
    getBrokerIncomeInfo: function () {
      var _getBrokerIncomeInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$brokerIncomeIn, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _broker.brokerIncomeInfo)();
            case 1:
              _yield$brokerIncomeIn = _context.v;
              code = _yield$brokerIncomeIn.code;
              data = _yield$brokerIncomeIn.data;
              if (code === 0) {
                this.brokerIncomeInfo = data.brokerIncomeInfo;
              }
              this.listLoading = false;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getBrokerIncomeInfo() {
        return _getBrokerIncomeInfo.apply(this, arguments);
      }
      return getBrokerIncomeInfo;
    }(),
    _isMobile: function _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    },
    forceRefresh: function forceRefresh() {
      window.location.href = window.location.href + '?ran=' + Math.random();
    }
  }
};